import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react';
import './index.css'
import App from './App.tsx'
import { initSentry } from './lib/sentry';

// Initialize Sentry before React
initSentry();

// Catch non-fatal storage initialization errors (localforage/IndexedDB race conditions)
// These occur when Supabase auth and Dexie compete for IndexedDB during startup
window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message || String(event.reason);
  if (msg.includes('localforage') || msg.includes('ready promise has not settled')) {
    console.warn('[Startup] Suppressed non-fatal storage init error:', msg);
    event.preventDefault();
  }
});
window.addEventListener('error', (event) => {
  const msg = event.message || '';
  if (msg.includes('localforage') || msg.includes('ready promise has not settled')) {
    console.warn('[Startup] Suppressed non-fatal storage init error:', msg);
    event.preventDefault();
  }
});

// Wrap App with error boundary
const SentryApp = Sentry.withErrorBoundary(App, {
  fallback: ({ error, resetError }) => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>Something went wrong</h1>
      <p>{error.message}</p>
      <button onClick={resetError}>Try again</button>
    </div>
  ),
  showDialog: false,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryApp />
  </StrictMode>,
)
